import React from 'react';

const About = () => {
  const universities = [
    {
      name: 'Heriot-Watt University Dubai',
      logo: 'https://customer-assets.emergentagent.com/job_dubai-education/artifacts/fex37ykr_hwud%20logo.svg'
    },
    {
      name: 'Murdoch University',
      logo: 'https://customer-assets.emergentagent.com/job_dubai-education/artifacts/7k9u7mj1_murdoch%20logo.png'
    },
    {
      name: 'RIT Dubai',
      logo: 'https://customer-assets.emergentagent.com/job_dubai-education/artifacts/lc3unuxz_rit%20dubai%20logo.png'
    },
    {
      name: 'Symbiosis',
      logo: 'https://customer-assets.emergentagent.com/job_dubai-education/artifacts/vlhau32m_symbiosis%20logo.svg'
    },
    {
      name: 'University of Birmingham',
      logo: 'https://customer-assets.emergentagent.com/job_dubai-education/artifacts/i2304g27_University%20of%20Birmingham%20dubai%201.png'
    },
    {
      name: 'SP Jain',
      logo: 'https://customer-assets.emergentagent.com/job_dubai-education/artifacts/tyk9twg3_UJziLF3jfuJgoyqV1U5xVQ8K.jpeg'
    },
    {
      name: 'University of Wollongong Dubai',
      logo: 'https://customer-assets.emergentagent.com/job_dubai-education/artifacts/iatg2znr_uowd-logo.png'
    },
    {
      name: 'Middlesex University Dubai',
      logo: 'https://customer-assets.emergentagent.com/job_dubai-education/artifacts/lmefnyeb_logo_mdx_95d90243df.png'
    },
    {
      name: 'BITS Pilani Dubai',
      logo: 'https://customer-assets.emergentagent.com/job_dubai-education/artifacts/wq9t9678_birla-institute-of-technology-and-science-pilani-dubai-uae.webp'
    }
  ];

  return (
    <>
      <section id="about" className="about-section">
        <div className="about-container">
          <div className="about-content-with-image">
            <div className="about-text-content">
              <h2 className="about-title">Meet Karishma Mansukhani, Founder of Dream Big Education</h2>
              <div className="about-description">
                <p>
                  With 10 years of experience in higher education and career counselling, Karishma has guided over 1,000 students from around the world, including the Middle East and India, helping them find the right courses, countries, and career paths that truly fit who they are.
                </p>
                <p>
                  Born and brought up in Dubai, she understands the city's education ecosystem, culture, and lifestyle first-hand, giving her a deep perspective when guiding students who choose to study or build their futures there.
                </p>
                <p>
                  Her approach? No surface-level advice, no pressure - just real conversations that help students and parents move forward in the right direction.
                </p>
                <p>
                  Her style? Clear, communicative, practical, and completely student-focused.
                </p>
                <p>
                  At Dream Big Education, Karishma continues to support students in turning their aspirations into action - one conversation, one application, and one dream at a time.
                </p>
              </div>
            </div>
            <div className="about-image-container">
              <img 
                src="https://customer-assets.emergentagent.com/job_dubai-education/artifacts/jkjqxx3z_1647367179328.jpeg" 
                alt="Karishma Mansukhani - Founder of Dream Big Education, expert education counselor with 10 years experience"
                className="founder-photo"
              />
            </div>
          </div>

          <div className="university-banner-section">
            <h3 className="banner-headline">Where Her Students Are Living Their Dream</h3>
            <div className="logo-banner">
              <div className="logo-track">
                {[...universities, ...universities, ...universities].map((uni, index) => (
                  <div key={index} className="logo-item">
                    <img src={uni.logo} alt={uni.name} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="wave-divider">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#9fe2ff"></path>
        </svg>
      </div>
    </>
  );
};

export default About;